export default "__VITE_ASSET__6URJ2N1G__"